import { Serializer } from 'survey-core';
import { PropertyGridEditorCollection } from 'survey-creator-core';

export function registerSimpleCustomProperties(): void {
  Serializer.addProperty('survey', {
    name: 'customSurveyPropAnon',
    category: 'general',
    type: 'boolean',
    visibleIndex: 3,
    default: false,
  });

  Serializer.addProperty('survey', {
    name: 'customSurveyNoMail',
    category: 'general',
    type: 'boolean',
    visibleIndex: 4,
    default: false,
  });

  Serializer.addProperty('survey', {
    name: 'customRemember',
    category: 'general',
    type: 'boolean',
    visibleIndex: 5,
    default: false,
  });

  Serializer.addProperty('survey', {
    name: 'customShowScoreResultOnComplete',
    category: 'general',
    type: 'boolean',
    visibleIndex: 6,
    default: 0,
    minValue: 0,
    maxValue: Math.floor(0x7FFFFFFF / 86400),
  });

  Serializer.addProperty('survey', {
    name: 'customValidForDays',
    category: 'general',
    type: 'number',
    visibleIndex: 7,
    default: 0,
    minValue: 0,
    maxValue: Math.floor(0x7FFFFFFF / 86400),
  });

  Serializer.addProperty('survey', {
    name: 'customShowStillValidToast',
    category: 'general',
    type: 'boolean',
    visibleIndex: 8,
    default: false,
  });

  PropertyGridEditorCollection.register({  // register custom editor for timer type, as it is not supported by default
    fit: (prop) => prop.type === 'timer',
    getJSON: (obj, prop, options) => {
      return {
        type: 'text',
        inputType: 'time', // Uses the browser's <input type="time">
      };
    },
  });

  Serializer.addProperty('survey', {
    name: 'customRunnableTimeStart',
    category: 'timer',
    type: 'timer',
    visibleIndex: 710,
    default: '00:00',
  });

  Serializer.addProperty('survey', {
    name: 'customRunnableTimeStop',
    category: 'timer',
    type: 'timer',
    visibleIndex: 711,
    default: '23:59',
  });

  Serializer.addProperty('survey', {
    name: 'customFutureMarkDoneDate',
    category: 'timer',
    type: 'number',
    visibleIndex: 712,
    default: 0,
    minValue: 0,
    maxValue: Math.floor(0x7FFFFFFF / 86400),
  });

  Serializer.addProperty('html', {//used to distinguish normal HTML elements from those that were imported (e.g. from a PDF)
    name: 'customWasImported',
    category: 'general',
    type: 'boolean',
    default: false,
    visible: false, //hidden property
  });

  Serializer.addProperty('text', {
    name: 'isPhoneNumberAlarmEnabled',
    category: 'general',
    type: 'boolean',
    visibleIndex: 8,
    default: false,
    visibleIf: function (obj: any) {
      return obj?.inputType === 'tel';
    },
  });
}